import React from 'react';
import { dashToPascalCase } from '../../../Utils/string';
import { isEventProp, normalizeEventPropName } from './utils';
export function createReactComponent({ tagName, defaultProps, defineCustomElement, }) {
    let isRegistered = false;
    const ReactComponent = (props) => {
        if (!isRegistered) {
            if (defineCustomElement !== undefined) {
                defineCustomElement();
                isRegistered = true;
            }
        }
        const propsToPass = Object.entries(props).reduce((acc, [propName, propValue]) => {
            if (isEventProp(propName)) {
                return Object.assign(Object.assign({}, acc), { [`${normalizeEventPropName(propName)}`]: propValue });
            }
            return Object.assign(Object.assign({}, acc), { [propName]: propValue });
        }, {});
        return React.createElement(tagName, Object.assign(Object.assign({}, defaultProps), propsToPass));
    };
    ReactComponent.displayName = `${dashToPascalCase(tagName)}`;
    return ReactComponent;
}
